/* eslint-disable camelcase */
import React, { useState } from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { useStateCode } from '~state/getStateField';
import updatePersonFields from '~actions/updatePersonFields';
import {
  defaultErrorState,
  ValidationErrors,
} from '~components/forms/SubmissionHelpers';
import redirectToFutureVoter from '~components/Register/redirectToFuturevoter';
import { Formik } from 'formik';
import ScrollIfValidationError from '~components/forms/ScrollIfValidationError';
import { CustomizableButton } from '~components/common/Button';
import InputGroup from '~components/forms/inputs/Field';
import { phoneRequiredValidator } from '~components/forms/blocks/ContactInformationBlock';
import * as Yup from 'yup';
import {
  SmsOptInVoteAmerica,
  PhoneOnlyDisclaimerVoteAmerica,
} from '~components/forms/OptIn';
import useRegisterRedirect from './useRegisterRedirect';
import ContentDiv from '../common/ContentDiv';

function IneligibleAge() {
  const dispatch = useDispatch();
  const stateCode = useStateCode();
  const person = useSelector((state) => state.person);
  const registerFields = useSelector((state) => state.registerFields);

  const initialValues = {
    phone: person.phone,
    sms_opt_in_voteamerica: registerFields.sms_opt_in_voteamerica,
  };

  const formError = _.cloneDeep(defaultErrorState);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleReferralToFutureVoter = (formData) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    dispatch(updatePersonFields(formData));

    const registerFieldsStateUpdate = {
      sms_opt_in_voteamerica: formData.sms_opt_in_voteamerica,
    };
    dispatch({
      type: 'REGISTER_UPDATE_FIELDS',
      registerFields: registerFieldsStateUpdate,
    });

    redirectToFutureVoter();
    setIsSubmitting(false);
  };

  const ValidationSchema = Yup.object().shape({
    phone: phoneRequiredValidator,
    sms_opt_in_voteamerica: Yup.bool(),
  });

  useRegisterRedirect('ineligible-age');
  if (!stateCode) {
    return null;
  }

  return (
    <ContentDiv>
      <h1>You may be old enough to pre-register</h1>
      <p>
        Even though you are too young to vote, most states allow you to register
        to vote before you turn 18.
      </p>
      <p>
        Our FutureVoter program can help you determine whether you are eligible.
        We just need your cell phone number so we can text you on your 18th
        birthday to remind you to confirm your registration.
      </p>

      <Formik
        initialValues={initialValues}
        validationSchema={ValidationSchema}
        onSubmit={handleReferralToFutureVoter}
        validateOnMount
      >
        {({ handleSubmit, isValid, submitCount }) => (
          <form
            id='register-under18'
            onSubmit={handleSubmit}
            noValidate='novalidate'
          >
            <ScrollIfValidationError scrollToElement='h1' />
            <div className='space-y-10'>
              {!isValid && submitCount > 0 ? (
                <ValidationErrors />
              ) : (
                formError.error && <ValidationErrors {...formError} />
              )}
              <InputGroup
                name='phone'
                label='Cell phone'
                type='tel'
                errors={formError.fieldErrors}
                required
                inputMask='(000) 000-0000'
              />
              <SmsOptInVoteAmerica errors={formError.fieldErrors} />
              <PhoneOnlyDisclaimerVoteAmerica />
              <CustomizableButton
                type='submit'
                id='register_under-18_referral'
                isSubmitting={isSubmitting}
                data-element-id='btn_x_continue'
                formSubmit
                elementType='button'
              >
                See if you can pre-register
              </CustomizableButton>
            </div>
          </form>
        )}
      </Formik>
    </ContentDiv>
  );
}

export default IneligibleAge;
